import { actions, config, HistoryRouter, mui, React, Route, Routes, Sentry, ui, useSelector } from '_core';
import api, { initApi } from '_core/api';
import { store } from '_core/store';

import { FinseraCoreProvider, uitheme } from '@local/finsera-core';
import { LicenseInfo } from '@mui/x-license';
import Global from 'global';
import InApp from 'in-app';

import { browserHistory } from './history';

if (!config.environment.match(/local/)) {
  Sentry.init({
    dsn: 'https://0492e029ccf5431d888e10f88174eab6@o408418.ingest.sentry.io/5279214',
    environment: config.environment,
    beforeSend(event) {
      // Only allow errors that are manually captured
      const isManualCapture = event.tags?.manual || false;
      return isManualCapture ? event : null;
    },
  });
}
// Init muix
// eslint-disable-next-line max-len
LicenseInfo.setLicenseKey(
  // eslint-disable-next-line max-len
  'ae4833c8e5a63e7fd9eb6395327ade8dTz0xMTQzNjgsRT0xNzgxMTM1OTk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y'
);

initApi(store, actions);

const App = () => {
  const productionMode = useSelector((state) => state.ui.currentTab == 'production');
  const authenticated = useSelector((state) => state.auth.authenticated);
  const features = React.useMemo(() => {
    return config.features;
  }, [authenticated]);

  return (
    <HistoryRouter history={browserHistory}>
      <FinseraCoreProvider
        key={authenticated.toString()}
        store={store}
        features={features}
        actions={actions}
        history={browserHistory}
        api={api}
      >
        <mui.core.ThemeProvider theme={productionMode ? uitheme.green : uitheme.blue}>
          <ui.OnlineCheck.Offline
            polling={
              {
                url: '/api/v1/healthz',
                enabled: true,
              } as any
            }
          >
            <ui.OfflineModal />
          </ui.OnlineCheck.Offline>

          <Routes>
            <Route path="/_global" element={<Global />}>
              <Route path="*" element={<Global />} />
            </Route>
            <Route path="*" element={<InApp />} />
          </Routes>
        </mui.core.ThemeProvider>
      </FinseraCoreProvider>
    </HistoryRouter>
  );
};

export default App;
